import {Injectable} from '@angular/core';
import * as Values from 'src/app/infrastructure/form/values/customer.values';

@Injectable({
  providedIn: 'root',
})
export default class CustomerFormValuesResolver {
  getGenderList(): string[] {
    return Values.gender;
  }

  getEmploymentStatusList(): string[] {
    return Values.employmentStatus;
  }

  getMaritalStatusList(): string[] {
    return Values.maritalStatus;
  }

  getMaritalRegimeList(): string[] {
    return Values.maritalRegime;
  }

  getCurrentAmountInvestedInPensionPlansList(): string[] {
    return Values.currentAmountInvestedInPensionPlans;
  }

  getPublicChargeList(): string[] {
    return Values.publicCharge;
  }

  getPublicChargeKindList(): string[] {
    return Values.publicChargeKind;
  }

  getIncomeOriginList(): string[] {
    return Values.incomeOrigin;
  }

  getIncomeVolumeList(): string[] {
    return Values.incomeVolume;
  }

  getMappedIncomeVolumes(): string[] {
    const incomeVolumes = [];

    this.getIncomeVolumeList().forEach((value: string) => {
      switch (value) {
        case '<15000': incomeVolumes.push('lessThan15000');
          break;
        case '<30000': incomeVolumes.push('between15000And30000');
          break;
        case '<45000': incomeVolumes.push('between30000And45000');
          break;
        case '<60000': incomeVolumes.push('between45000And60000');
          break;
        case '<75000': incomeVolumes.push('between60000And75000');
          break;
        case '<100000': incomeVolumes.push('between75000And100000');
          break;
        case '>100000': incomeVolumes.push('greaterThan100000');
          break;
        default: incomeVolumes.push(value);
      }
    });

    return incomeVolumes;
  }

  getFundsOriginList(): string[] {
    return Values.fundsOrigin;
  }
}
